import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _css, _css2, _templateObject, _span, _css3, _css6, _input;
import { css, keyframes } from '@emotion/react';
import { defaultEmojiHeight } from '../../util/constants';
import { akEmojiSelectedBackgroundColor } from '../../util/shared-styles';
import { B100, N20, N200, N20A, N300, N400, N900, R300, R400 } from '@atlaskit/theme/colors';
import { fontFamily as getFontFamily } from '@atlaskit/theme/constants';
export var commonSelectedStyles = 'emoji-common-selected';
export var selectOnHoverStyles = 'emoji-common-select-on-hover';
export var emojiSprite = 'emoji-common-emoji-sprite';
export var emojiNodeStyles = 'emoji-common-node';
export var emojiImage = 'emoji-common-emoji-image';
export var emojiDeleteButton = 'emoji-common-deleteButton';
export var emojiMainStyle = 'emoji-common-main-styles';
export var deletableEmoji = 'emoji-common-deletable';
export var deleteButton = css({
  // hide by default
  visibility: 'hidden',
  display: 'flex',
  position: 'absolute',
  top: "var(--ds-space-negative-100, -8px)",
  right: "var(--ds-space-negative-100, -8px)",
  zIndex: 1
});
export var emojiToneSelectorContainer = css({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '10px 10px 11px 0'
});
export var emojiImageContainer = css((_css = {
  borderRadius: "var(--ds-border-radius-100, 3px)",
  backgroundColor: 'transparent',
  display: 'inline-block',
  verticalAlign: 'middle',
  // Ensure along with vertical align middle, we don't increase the line height for p and some
  // headings. Smaller headings get a slight increase in height, cannot add more negative margin
  // as a "selected" emoji (e.g. in the editor) will not look good.
  margin: '-1px 0',
  img: {
    display: 'block'
  }
}, _defineProperty(_css, "&.".concat(commonSelectedStyles, ",&.").concat(selectOnHoverStyles, ":hover"), {
  backgroundColor: akEmojiSelectedBackgroundColor
}), _defineProperty(_css, "&.".concat(commonSelectedStyles, ",&.").concat(selectOnHoverStyles, ":hover .").concat(emojiDeleteButton), {
  // show delete button on hover
  visibility: 'visible'
}), _defineProperty(_css, "&.".concat(deletableEmoji), {
  position: 'relative'
}), _defineProperty(_css, "&.".concat(deletableEmoji, ":focus-within .").concat(emojiDeleteButton), {
  visibility: 'visible'
}), _defineProperty(_css, '&:focus', {
  boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")),
  transitionDuration: '0s, 0.2s',
  outline: 'none'
}), _css));
export var emojiSpriteContainer = css((_css2 = {
  display: 'inline-block',
  // Ensure along with vertical align middle, we don't increase the line height for h1..h6, and p
  margin: '-1px 0'
}, _defineProperty(_css2, "&.".concat(commonSelectedStyles, ",&.").concat(selectOnHoverStyles, ":hover"), {
  backgroundColor: akEmojiSelectedBackgroundColor
}), _defineProperty(_css2, ".".concat(emojiSprite), {
  background: 'transparent no-repeat',
  display: 'inline-block',
  minHeight: "".concat(defaultEmojiHeight, "px"),
  minWidth: "".concat(defaultEmojiHeight, "px"),
  verticalAlign: 'middle'
}), _defineProperty(_css2, '&:focus', {
  boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")),
  transitionDuration: '0s, 0.2s',
  outline: 'none'
}), _css2));
export var placeholder = 'emoji-common-placeholder';
export var placeholderContainer = css({
  position: 'relative',
  margin: '-1px 0',
  display: 'inline-block',
  background: "var(--ds-border, #f7f7f7)",
  borderRadius: "var(--ds-border-radius-100, 3px)",
  overflow: 'hidden',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  textAlign: 'center'
});
var easeSweep = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: translateX(-100%);\n  }\n  to   {\n    transform: translateX(100%);\n  }\n"])));
export var placeholderContainerAnimated = css({
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    background: "var(--ds-background-neutral, ".concat(N20A, ")"),
    height: '100%',
    width: '100%',
    animation: "".concat(easeSweep, " 1s cubic-bezier(0.4, 0.0, 0.2, 1) infinite")
  }
});
export var hidden = css({
  opacity: 0,
  visibility: 'hidden',
  display: 'none'
});
export var emojiButton = css((_css3 = {
  backgroundColor: 'transparent',
  border: '0',
  borderRadius: "var(--ds-border-radius-100, 3px)",
  cursor: 'pointer',
  padding: 0,
  position: 'relative',
  display: 'inline-block'
}, _defineProperty(_css3, '&::-moz-focus-inner', {
  border: '0 none',
  padding: 0
}), _defineProperty(_css3, '&>span', (_span = {
  padding: "var(--ds-space-075, 6px)"
}, _defineProperty(_span, "&>.".concat(emojiSprite), {
  height: '24px',
  width: '24px'
}), _defineProperty(_span, "&>img", {
  height: '24px',
  width: '24px'
}), _span)), _defineProperty(_css3, '&:focus', {
  boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")),
  transitionDuration: '0s, 0.2s',
  outline: 'none'
}), _css3));
export var emojiRadio = css({
  opacity: 0,
  position: 'absolute',
  top: '-10px',
  left: '-10px',
  '+span': {
    borderRadius: "var(--ds-border-radius-100, 3px)"
  },
  '&:focus + span': {
    boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")),
    transitionDuration: '0s, 0.2s',
    outline: 'none'
  }
});

// Emoji Preview
export var emojiPickerAddEmoji = 'emoji-picker-add-emoji';
export var previewText = css({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  marginTop: "var(--ds-space-negative-025, -2px)",
  marginLeft: '10px',
  maxWidth: '285px',
  width: '285px' /* IE */,
  flexGrow: 1,
  flexShrink: 1
});
export var emojiName = css(_defineProperty({
  display: 'block',
  color: "var(--ds-text, ".concat(N900, ")"),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, '&:first-letter', {
  textTransform: 'uppercase'
}));
export var emojiShortName = css(_defineProperty({
  display: 'block',
  color: "var(--ds-text-subtle, ".concat(N200, ")"),
  fontSize: '12px',
  lineHeight: 1,
  marginBottom: "var(--ds-space-negative-025, -2px)",
  overflow: 'hidden',
  paddingBottom: "var(--ds-space-025, 2px)",
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, '&:first-of-type', {
  color: "var(--ds-text, ".concat(N900, ")"),
  fontSize: '14px'
}));
export var preview = css({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  padding: '10px',
  height: '32px',
  alignItems: 'center'
});
export var previewImg = css((_css6 = {
  display: 'inline-block',
  flex: 'initial',
  width: '32px'
}, _defineProperty(_css6, "& .".concat(emojiSprite, ", span[role=\"img\"]"), {
  width: '32px',
  height: '32px',
  padding: 0,
  maxHeight: 'inherit'
}), _defineProperty(_css6, "& span[role=\"img\"] > img", {
  position: 'relative',
  left: '50%',
  top: '50%',
  transform: 'translateX(-50%) translateY(-50%)',
  maxHeight: '32px',
  maxWidth: '32px',
  padding: 0,
  display: 'block'
}), _css6));

// Scrollable

export var emojiScrollable = css({
  border: "1px solid ".concat("var(--ds-border, #fff)"),
  borderRadius: "var(--ds-border-radius-100, 3px)",
  display: 'block',
  margin: '0',
  overflowX: 'hidden',
  overflowY: 'auto',
  padding: '0'
});

// EmojiUpload

export var emojiUpload = css({
  height: '78px',
  padding: '10px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around'
});
export var emojiUploadTop = css({
  paddingBottom: '7px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  fontSize: '12px'
});
export var uploadChooseFileMessage = css({
  '&&': {
    color: "var(--ds-text-subtle, ".concat(N300, ")")
  }
});
export var closeEmojiUploadButton = css({
  display: 'flex'
});
export var emojiUploadBottom = css({
  fontSize: '11px'
});
export var uploadChooseFileRow = css({
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: '7px'
});
export var uploadChooseFileEmojiName = css({
  flex: '1 1 auto',
  marginRight: '5px',
  input: (_input = {
    background: 'transparent',
    border: 0,
    outline: 'none'
  }, _defineProperty(_input, '&:invalid', {
    boxShadow: 'none'
  }), _defineProperty(_input, '&::-ms-clear', {
    display: 'none'
  }), _input)
});
export var uploadChooseFileBrowse = css({
  flex: '0 0 auto'
});
export var uploadPreviewFooter = css({
  display: 'flex',
  flexDirection: 'column',
  height: '100px',
  padding: '10px'
});
export var uploadPreview = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: "var(--ds-background-neutral, ".concat(N20, ")"),
  borderRadius: "var(--ds-border-radius-100, 3px)",
  padding: '10px'
});
export var uploadPreviewText = css({
  h5: {
    color: "var(--ds-text-subtle, ".concat(N300, ")"),
    paddingBottom: "var(--ds-space-050, 4px)",
    fontSize: '12px'
  },
  img: {
    maxHeight: '20px',
    maxWidth: '50px'
  }
});
export var bigEmojiPreview = css({
  paddingLeft: "var(--ds-space-050, 4px)",
  img: {
    maxHeight: '40px',
    maxWidth: '100px'
  }
});
export var uploadAddRow = css({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  paddingTop: '10px'
});
export var addCustomEmoji = css({
  alignSelf: 'center',
  marginLeft: '10px',
  marginBottom: '10px'
});

// Emoji Delete preview

export var submitDelete = 'emoji-submit-delete';
export var deletePreview = css({
  height: '100px',
  padding: '10px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end'
});
export var deleteText = css({
  height: '64px',
  fontSize: '12px',
  '&:first-of-type': {
    color: "var(--ds-text-subtle, ".concat(N300, ")"),
    lineHeight: '16px'
  }
});
export var headingH5 = css({
  '&&': {
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.003em',
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
  }
});
export var requiredSymbol = css({
  paddingLeft: "var(--ds-space-025, 2px)",
  color: "var(--ds-text-danger, ".concat(R400, ")"),
  fontFamily: getFontFamily()
});
export var previewButtonGroup = css({
  display: 'flex'
});
export var deleteFooter = css(_defineProperty({
  display: 'flex',
  height: '40px',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: "var(--ds-font-size-100, 14px)",
  img: {
    maxHeight: '32px',
    maxWidth: '72px'
  }
}, ".".concat(submitDelete), {
  width: '84px',
  fontWeight: 'bold',
  marginRight: "var(--ds-space-050, 4px)"
}));
export var emojiDeleteErrorMessage = css({
  display: 'flex',
  color: "var(--ds-text-danger, ".concat(R400, ")"),
  alignItems: 'center',
  justifyContent: 'flex-end',
  paddingRight: "var(--ds-space-050, 4px)"
});
export var emojiChooseFileErrorMessage = css({
  display: 'flex',
  color: "var(--ds-text-danger, ".concat(R300, ")"),
  paddingRight: '10px',
  justifyContent: 'flex-start'
});
export var emojiPreviewErrorMessage = css({
  display: 'inline-flex',
  color: "var(--ds-text-danger, ".concat(R400, ")"),
  paddingRight: '10px',
  justifyContent: 'flex-end',
  alignItems: 'center'
});
export var addCustomEmojiButton = css({
  maxWidth: '285px'
});
export var uploadRetryButton = css({
  maxWidth: '172px',
  justifyContent: 'center',
  fontWeight: 'bold',
  marginRight: "var(--ds-space-050, 4px)",
  div: {
    display: 'flex'
  }
});
export var uploadEmojiButton = css({
  maxWidth: '187px',
  justifyContent: 'center',
  marginRight: "var(--ds-space-050, 4px)",
  div: {
    display: 'flex'
  }
});
export var cancelButton = css({
  maxWidth: '100px'
});
export var buttonSpinner = css({
  marginRight: '10px',
  marginLeft: '10px'
});
export var emojiActionsWrapper = css({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center'
});
export var tooltipShortcutStyle = css({
  borderRadius: '3px',
  backgroundColor: "var(--ds-background-inverse-subtle, ".concat(N400, ")"),
  padding: "0 ".concat("var(--ds-space-025, 2px)"),
  /* TODO: fix in develop: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E */
  /* stylelint-disable-next-line */
  label: 'tooltip-shortcut'
});